import React from 'react';
import { ResponsiveContext, Box, Text, Meter } from 'grommet';
import { formattedNumber } from '../../utils';

const Statistic = ({ title, graph, label }) => {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          pad={{ bottom: 'small' }}
          flex={{ shrink: 0 }}
          gap='xsmall'
        >
          <Box
            direction='row'
            justify='between'
          >
            <Text
              size='small'
              color='dark-3'
            >
              {title}
            </Text>

            <Text
              size='small'
              color='dark-5'
            >
              {formattedNumber(label.value, label.formatter, label.precision ?? 2)}
            </Text>
          </Box>

          <Box>
            <Meter
              max={100}
              background='light-3'
              size='full'
              type='bar'
              thickness='small'
              values={[
                {
                  color: graph.color,
                  value: graph.value * 100,
                  label: title
                }
              ]}
            />
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export default Statistic;
